export default __webpack_public_path__ + "static/media/cameragot-screenshot-03.1cd91a08.png";